import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { OnlyAviaPackage } from '@appTypes/api.types';
import { SVGIcon } from '@data/svg-icons.data';
import { FlightClassComponent } from '@shared/components/flight-class/flight-class.component';
import { PriceFormatPipe } from '@shared/pipes/price-format.pipe';
import { RunFunctionPipe } from '@shared/pipes/run-function.pipe';
import { airlineLogoIcon } from '@core/services/airline-logos.service';

@Component({
  selector: 'app-cart-avia-item-view',
  templateUrl: './cart-avia-item-view.component.html',
  styleUrl: './cart-avia-item-view.component.scss',
  imports: [MatIcon, FlightClassComponent, PriceFormatPipe, RunFunctionPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartAviaItemViewComponent {
  readonly data = input<OnlyAviaPackage>();

  /** R-FC38 (flight-catalogue qa.md): the airline's logo from NugiosCore, resolved by AirlineLogoIconRegistry. */
  getAirlineIconFn = (airlineId: string): SVGIcon => airlineLogoIcon(airlineId);
}
